import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useAppState } from 'src/shared/appState';
import { SidebarOnboardingPanelFragment$key } from './__generated__/SidebarOnboardingPanelFragment.graphql';

const SidebarOnboardingPanel = () => {
    const { queryData } = useAppState();
    const query = useFragment<SidebarOnboardingPanelFragment$key>(
        graphql`
            fragment SidebarOnboardingPanelFragment on Query {
                user {
                    userID
                    email
                    name
                }
                testOrdersCount
                treeMenuReferringInfo {
                    daysOfTrial
                    firstNotPublishedProductID
                    hasFirstCustomizableProduct
                    hasPublishedProduct
                    hasStoreConnected
                    isAdministrator
                    isComposerEnabled
                    isExternalLinksHidden
                    isHelpWidgetHidden
                    isMenuHidden
                    isNoViewsPlan
                    isSubscriptionCanceled
                    isSubscriptionSubStatusBlocked
                    isToolbarHidden
                    isTrial
                    isVisibleSubscribePlan
                    noValidSubscriptionReason
                    planVersion
                    remoteUrl
                    sellerAppsumoMarketplaceID
                    subscriptionCancel
                    toolbarForceTools
                    urlComposer
                    userType
                }
            }
        `,
        queryData?.SidebarOnboardingPanelFragment ?? null
    );

    // The onboarding checklist and the trial callout now live on the dashboard, so the sidebar shows
    // nothing here. The fragment stays so the parent query composition is unchanged.
    void query;
    return null;
};

export default SidebarOnboardingPanel;
